<template>
  <div class="toolbar noprint">
    <!-- USER MENU -->
    <UserMenu />
    <!-- NAVIGATION -->
    <Navigation />
    <!-- MENU MOBILE -->
    <FloatMenu ref="$floatMenuRef" />
  </div>
</template>

<script setup>
import {
  ref,
} from 'vue';
// #endregion

import FloatMenu from '@/components/float-menu/FloatMenu.vue';
import Navigation from '@/components/navigation/Navigation.vue';
import UserMenu from '@/components/user-menu/UserMenu.vue';

// #region Params, Ref, Reactives, Computed
const $floatMenuRef = ref(null);
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.toolbar{
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  height: 100%;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  width: 100%;

  @include media(">desktop") {
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
  }

  @include media("<=desktop") {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
}
</style>
